import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#505050",
      d: "M10.275 4.698c.78 0 1.537.1 2.26.286a.75.75 0 0 1-.375 1.452 7.527 7.527 0 1 0 5.404 5.403.75.75 0 0 1 1.453-.374 9.026 9.026 0 1 1-8.741-6.767"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#505050",
      "fill-rule": "evenodd",
      d: "M17.41 1.402a.75.75 0 0 1 1.188.45l.414 2.075 1.767-1.767a.75.75 0 0 1 1.06 1.06l-1.767 1.767 2.076.415a.75.75 0 0 1 .382 1.266l-2.759 2.759a.75.75 0 0 1-.676.205l-3.057-.611-1.326 1.327a5.578 5.578 0 1 1-1.06-1.06l1.327-1.329-.61-3.054a.75.75 0 0 1 .204-.676l2.759-2.76zM10.274 9.65a4.078 4.078 0 1 0 3.364 1.772l-2.833 2.834a.75.75 0 0 1-1.06-1.06l2.832-2.835a4.06 4.06 0 0 0-2.303-.711m7.039-1.903 1.68.336 1.485-1.484-1.681-.336zm-1.397-2.741.336 1.68 1.484-1.484-.336-1.68z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }